import { useCallback, useState } from "react";

import { modules, useFeature, useObjectMemo } from "byzantine";
import { useNavigate } from "react-router-dom";
import ApiHttp from "byzantine/src/ApiHttp";

import { PAYMENT_ACTIVITY_ROUTE } from "../../../../../../components/PaymentActivity/routes";

type UIState = "form" | "2FA" | "review";

export const useSendViaTemplate = () => {
  const { onContinue } = modules.wireTemplates.useSubmitSendViaTemplateForm();
  const { featureEnabled } = useFeature();
  const { createWireViaTemplate: onSubmit, loading } =
    modules.wireTemplates.useCreateWireViaTemplate();
  const [uiState, setUiState] = useState<UIState>("form");
  const navigate = useNavigate();

  const submitReview = useCallback(
    (idempotencyKey: UUID) => {
      onSubmit(idempotencyKey, {
        onSuccess: (wire) => {
          if (wire?.id && featureEnabled("payment_activity")) {
            window.location.assign(`/${PAYMENT_ACTIVITY_ROUTE}/${wire.id}`);
          } else {
            navigate("/");
          }
        },
        onError: () => setUiState("form"),
      });
    },
    [navigate, onSubmit, featureEnabled]
  );

  const submitForm = useCallback(async () => {
    const next = () => setUiState("review");
    const trySudo = () =>
      ApiHttp.fetch("sudo")
        .then(() => setUiState("review"))
        .catch(() => setUiState("2FA"));
    onContinue(next, trySudo);
  }, [onContinue]);

  const complete2FA = useCallback(() => {
    setUiState("review");
  }, []);

  const resetFlow = useCallback(() => {
    setUiState("form");
  }, []);

  const cancel = useCallback(() => {
    navigate("/");
  }, [navigate]);

  return useObjectMemo({
    uiState,
    submitForm,
    complete2FA,
    submitReview,
    resetFlow,
    loading,
    cancel,
  });
};
